import { render, staticRenderFns } from "./KukoProductList.vue?vue&type=template&id=18bef5a9&"
import script from "./KukoProductList.vue?vue&type=script&lang=js&"
export * from "./KukoProductList.vue?vue&type=script&lang=js&"
import style0 from "./KukoProductList.vue?vue&type=style&index=0&id=18bef5a9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports